import React from 'react';

interface WistiaVideoComponentProps {
  videoID: string;
}

const WistiaVideo: React.FC<WistiaVideoComponentProps> = ({ videoID }) => {
  return (
    <iframe 
      className="wistia_embed max-w-full" 
      frameBorder="0"
      height="450" 
      name="wistia_embed" 
      scrolling="no" 
      src={`https://fast.wistia.net/embed/iframe/${videoID}`}
      title="Wistia video player" 
      width="800"
      allowFullScreen
      allowTransparency
    ></iframe>
  );
}

export default WistiaVideo;